import React from "react";
import { Typography } from "@mui/material";
import AppModal from "../common/AppModal";
import FormAlert from "../common/FormAlert";
import LinkStudentToParentForm from "../../forms/LinkStudentToParentForm";
import { ParentGuardianSummaryDto } from "../../shared/dtos/parentGuardian/ParentGuardianSummaryDto";

interface LinkStudentModalProps {
  open: boolean;
  onClose: () => void;
  parent: ParentGuardianSummaryDto | null;
  loading: boolean;
  error: string | null;
}

const LinkStudentModal: React.FC<LinkStudentModalProps> = ({
  open,
  onClose,
  parent,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Link Student to ${parent?.firstName || "Parent"}`}
    width="sm"
    loading={loading}
  >
    <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
      Assign an existing student to this parent/guardian profile.
    </Typography>
    <FormAlert message={error} severity="error" />
    {parent && (
      <LinkStudentToParentForm parentId={parent.id} loading={loading} />
    )}
  </AppModal>
);

export default LinkStudentModal;
